<template>
  <div id="app">
    <h1>文本转换器</h1>
    <button @click="toggleHistory" class="btn">历史</button>
    <button @click="clearText" class="btn">清除</button>

    <div class="checkbox-container">
      <input type="checkbox" id="filterHairEyes" v-model="hair_eyes_colorFlitter">
      <label for="filterHairEyes">过滤发色与瞳色</label>
    </div>
    <div class="checkbox-container">
      <input type="checkbox" id="filterHairStyle" v-model="hair_styleFlitter">
      <label for="filterHairStyle">过滤发型</label>
    </div>
    <div class="checkbox-container">
      <input type="checkbox" id="filterRedundant" v-model="redundantFlitter">
      <label for="filterRedundant">过滤冗余标签</label>
    </div>

    <textarea v-model="inputText" placeholder="输入文本" class="large-input"></textarea>

    <!-- 新增的开关 -->
    <div class="checkbox-container">
      <input type="checkbox" id="pureFilter" v-model="pureFilter">
      <label for="pureFilter">不转换 纯过滤文本</label>
    </div>

    <button @click="transformText" class="btn">转换</button>
    <div class="output">{{ outputText }}</div>
    <p class="description">直接复制进来（不要包括中文）。</p>
    <button @click="copyToClipboard(outputText)" class="btn">复制到剪贴板</button>

    <div v-if="showHistory">
      <h2>历史记录</h2>
      <input v-model="search" placeholder="搜索历史..." class="search-input">
      <ul>
        <li v-for="(record, index) in paginatedHistory" :key="index" class="history-record">
          {{ record }}
        </li>
      </ul>
      <div class="pagination">
        <button @click="prevPage" :disabled="currentPage <= 1" class="btn small">上一页</button>
        <span>页码 {{ currentPage }} / {{ totalPages }}</span>
        <button @click="nextPage" :disabled="currentPage >= totalPages" class="btn small">下一页</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      inputText: '',
      outputText: '',
      history: [],
      showHistory: false,
      currentPage: 1,
      recordsPerPage: 10,
      hair_eyes_colorFlitter: true, // 跟踪勾选框状态
      hair_styleFlitter: true,
      redundantFlitter: true,
      search: '',
      pureFilter: false // 新增的开关状态
    };
  },
  computed: {
    filteredHistory() {
      return this.history.filter(record => record.includes(this.search));
    },
    totalPages() {
      return Math.ceil(this.filteredHistory.length / this.recordsPerPage);
    },
    paginatedHistory() {
      let start = (this.currentPage - 1) * this.recordsPerPage;
      let end = start + this.recordsPerPage;
      return this.filteredHistory.slice(start, end);
    }
  },
  methods: {
    transformText() {
      const options = {
        hair_eyes_colorFlitter: this.hair_eyes_colorFlitter,
        hair_styleFlitter: this.hair_styleFlitter,
        redundantFlitter: this.redundantFlitter
        // 未来可以在这里添加更多的选项
      };

      this.outputText = this.processText(this.inputText, options);

      if (this.outputText.trim() !== '') {
        this.history.unshift(this.outputText);
      }
    },

    processText(source, options) {
      let tagList = [];
      // 定义颜色列表、冗余列表和必杀词列表
      const colorList = ['amber', 'blonde','amethyst', 'apricot', 'aqua', 'aqua marine', 'auburn', 'azure', 'beige', 'black', 'blue', 'bronze', 'brown', 'buff', 'burnt umber', 'cardinal', 'carmine', 'celadon', 'cerise', 'cerulean', 'char', 'coal', 'chartreuse', 'cinnamon', 'color', 'complementary', 'copper', 'coral', 'cream', 'crimson', 'cyan', 'dark', 'denim', 'desert sand', 'ebony', 'ecru', 'eggplant', 'emerald', 'forest green', 'fuchsia', 'gold', 'goldenrod', 'gray', 'green', 'grey', 'hot pink', 'hue', 'indigo', 'ivory', 'jade', 'jet', 'jungle green', 'kelly green', 'khaki', 'lavender', 'lemon', 'light', 'lilac', 'lime', 'magenta', 'mahogany', 'maroon', 'mauve', 'mustard', 'navy blue', 'ocher', 'olive', 'orange', 'orchid', 'pale', 'pastel', 'peach', 'periwinkle', 'persimmon', 'pewter', 'pink', 'primary', 'puce', 'pumpkin', 'purple', 'rainbow', 'red', 'rose', 'ruby', 'russet', 'rust', 'saffron', 'salmon', 'sapphire', 'scarlet', 'sea green', 'secondary', 'sepia', 'shade', 'shamrock', 'sienna', 'silver', 'slate', 'spectrum', 'steel blue', 'tan', 'tangerine', 'taupe', 'teal', 'terracotta', 'thistle', 'tint', 'tomato', 'topaz', 'turquoise', 'ultramarine', 'umber', 'vermilion', 'violet', 'viridian', 'wheat', 'white', 'wisteria', 'yellow'];
      const hairstyleList = ['very short hair', 'short hair', 'medium hair', 'long hair', 'very long hair', 'absurdly long hair', 'big hair', 'bald', 'bald girl', 'hairstyles', 'short hair', 'bob cut', 'inverted bob', 'bowl cut', 'buzz cut', 'chonmage', 'crew cut', 'flattop', 'okappa', 'pixie cut', 'undercut', 'medium hair', 'flipped hair', 'wolf cut', 'long hair', 'cornrows', 'dreadlocks', 'hime cut', 'mullet', 'tied hair', 'bow-shaped hair', 'braid', 'braided bangs', 'front braid', 'side braid', 'french braid', 'crown braid', 'single braid', 'multiple braids', 'twin braids', 'low twin braids', 'tri braids', 'quad braids', 'flower-shaped hair', 'hair bun', 'braided bun', 'single hair bun', 'double bun', 'cone hair bun', 'doughnut hair bun', 'heart hair bun', 'triple bun', 'cone hair bun', 'hair rings', 'single hair ring', 'half updo', 'one side up', 'two side up', 'low-braided long hair', 'low-tied long hair', 'mizura', 'multi-tied hair', 'nihongami', 'ponytail', 'folded ponytail', 'front ponytail', 'high ponytail', 'short ponytail', 'side ponytail', 'split ponytail', 'star-shaped hair', 'topknot', 'twintails', 'low twintails', 'short twintails', 'uneven twintails', 'tri tails', 'quad tails', 'quin tails', 'twisted hair', 'tall hair', 'afro', 'huge afro', 'beehive hairdo', 'crested hair', 'pompadour', 'quiff', 'shouten pegasus mix mori', 'hair texture', 'curly hair', 'drill hair', 'twin drills', 'tri drills', 'hair flaps', 'messy hair', 'pointy hair', 'ringlets', 'spiked hair', 'straight hair', 'wavy hair', 'front of the head', 'bangs', 'arched bangs', 'asymmetrical bangs', 'bangs pinned back', 'blunt bangs', 'crossed bangs', 'diagonal bangs', 'dyed bangs', 'fanged bangs', 'hair over eyes', 'hair over one eye', 'long bangs', 'parted bangs', 'curtained hair', 'ribbon bangs', 'short bangs', 'swept bangs', 'hair between eyes', 'hair intakes', 'single hair intake', 'sidelocks', 'asymmetrical sidelocks', 'drill sidelocks', 'low-tied sidelocks', 'sidelocks tied back', 'single sidelock', "widow's peak", 'top of the head', 'ahoge', 'heart ahoge', 'huge ahoge', 'antenna hair', 'heart antenna hair', 'comb over', 'hair pulled back', 'hair slicked back', 'mohawk', 'oseledets', 'back of the head', 'lone nape hair', 'head hair over the body', 'hair over shoulder', 'hair scarf', 'alternate hairstyle', 'asymmetrical hair', 'sidecut', 'blunt ends'];
      const redundantList = ['breasts'];
      const killList = ['aluba']; // 必杀词列表

      if (this.pureFilter) {
        // 使用逗号作为分隔符提取标签
        tagList = source.split(',').map(tag => tag.trim()).filter(tag => tag !== '');
      } else {
        // 原有的按行分割和提取标签的方式
        const lines = source.split('\n');
        lines.forEach(line => {
          if (line.trim() && line.trim() !== '?') {
            const parts = line.split(' ');
            if (parts.length > 1) {
              const phrase = parts.slice(0, -1).join(' ').replace('?', '').trim();
              tagList.push(phrase);
            }
          }
        });
      }

      let filteredTags = [];
      let outTags = [];

      tagList.forEach(tag => {
        const words = tag.split(' ');

        // 根据选项处理标签
        if (options.hair_eyes_colorFlitter) {
          // 过滤逻辑，例如处理颜色相关标签
          if (/\bhair\b/.test(tag)) {
            if (words.some(word => colorList.includes(word))) {
              outTags.push(tag);
              return;
            }
          }
          if (tag.includes('eyes')) {
            if (words.some(word => colorList.includes(word))) {
              outTags.push(tag);
              return;
            }
          }
        } 

        if (hairstyleList.includes(tag) && options.hair_styleFlitter) {
          outTags.push(tag);
          return;
        }

        if(options.redundantFlitter){
          // 处理冗余标签
          if (redundantList.includes(tag) || words.some(word => killList.includes(word))) {
            outTags.push(tag);
            return;
          }
        }
        
        filteredTags.push(tag); // 通过的直接添加标签
        
      });

      return filteredTags.join(',')
  
    },
    clearText() {
      this.inputText = '';
      this.outputText = '';
    },
    toggleHistory() {
      this.showHistory = !this.showHistory;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    copyToClipboard(text) {
      if (!text.trim()) {
        alert('没有可复制的内容！');
        return;
      }
      navigator.clipboard.writeText(text).then(() => {
        alert('文本已复制到剪贴板！');
      }).catch(err => {
        console.error('无法复制文本: ', err);
        alert('复制到剪贴板失败！');
      });
    }
  }
};
</script>

<style>
/* Root container styling */
#app {
  text-align: center;
  margin-top: 60px;
  font-family: 'Arial', sans-serif;
  background-color: #f9f4e8;
  color: #4d4d4d;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

/* Header */
h1 {
  margin-bottom: 20px;
  font-size: 2em;
  color: #4a4a4a;
}

/* Input area styling */
.large-input {
  width: 90%;
  height: 150px;
  margin: 20px auto;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.1);
}

/* Checkbox styling */
.checkbox-container {
  margin: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

input[type="checkbox"] {
  margin-right: 5px;
}

/* Button styling */
.btn {
  padding: 10px 20px;
  margin: 10px;
  background-color: #f08a24;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn:hover {
  background-color: #e07820;
}

.btn.small {
  padding: 5px 10px;
  font-size: 0.9em;
}

/* Output styling */
.output {
  margin: 20px auto;
  padding: 15px;
  width: 90%;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
  text-align: left;
  min-height: 50px;
}

/* Description */
.description {
  margin-top: 20px;
  color: #999;
  font-size: 0.9em;
}

/* History records */
.history-record {
  border-bottom: 1px solid #ddd;
  padding: 10px;
  text-align: left;
  background-color: #fff;
  margin: 5px 0;
  border-radius: 5px;
}

/* Search input */
.search-input {
  padding: 10px;
  width: 90%;
  margin-bottom: 15px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

/* Pagination */
.pagination {
  margin-top: 15px;
}

.pagination span {
  margin: 0 10px;
}
</style>